module.exports = __webpack_public_path__ + "static/img/12areaB_12.115e0c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_12.png
// module id = 1104
// module chunks = 1